"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var ErrorMsg_1 = __importDefault(require("./ErrorMsg"));
var Validation = function (_a) {
    var children = _a.children, name = _a.name, formikProps = _a.formikProps, rest = __rest(_a, ["children", "name", "formikProps"]);
    var errors = lodash_1.default.get(formikProps.errors, name);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.Children.map(children, function (child) {
            return react_1.default.cloneElement(child, __assign({ className: classnames_1.default(child.props.className, {
                    'invalid-input has-errors': lodash_1.default.get(formikProps.touched, name) && errors,
                }), name: name, id: name, validation_errors: errors }, rest));
        }),
        lodash_1.default.get(formikProps.touched, name) &&
            errors &&
            !lodash_1.default.isArray(errors) ? (react_1.default.createElement(ErrorMsg_1.default, { message: errors })) : null));
};
exports.default = Validation;
